import React, { Component } from 'react';
import { getEmployeeList } from '../../../utils/apiMiniWidget';
import {
  StyledBoxInside,
  StyledWrapperSearch,
  StyledWrapperEmployerDirectory,
  StyledWrapperPaginator,
  StyledButtonClear
} from './style';
import SearchFilterMini from '../../core/SearchFilterMini';
import SelectEmployerDirectory from '../../core/SelectEmployerDirectory';
import PaginatorVertical from '../../core/PaginatorVertical';
import InfiniteScroller from '../../core/InfiniteScroller';

class SelectEmployeeDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: undefined,
      modalActive: false,
      filter: {}
    };
    this.pageCounter = 1;
  }

  componentDidMount() {
    getEmployeeList({})
      .then(employeeData => {
        this.setState({ list: employeeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  onClick = formData => () => {
    const data = formData();
    this.setState({ list: null, dataForm: data });
    getEmployeeList(data)
      .then(employeeData => {
        this.setState({ list: employeeData, dataForm: data }, () =>
          this.closeModal()
        );
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  setFilter = filter => {
    this.setState({
      filter
    });
  };

  getFilters = () => this.state.filter;

  clearFilter = () => {
    getEmployeeList({})
      .then(employeeData => {
        this.setState({ list: employeeData, dataForm: {}, filter: {} }, () =>
          this.closeModal()
        );
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  openModal = () => {
    this.setState({ modalActive: true });
  };

  closeModal = () => {
    this.setState({ modalActive: false });
  };

  nextScroll = params => {
    this.pageCounter += 1;
    getEmployeeList(params)
      .then(employeeData => {
        this.setState({ list: employeeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  render() {
    const { list, modalActive, dataForm, filter } = this.state;
    const { resetRow, setEmployeeSelected } = this.props;
    let nextSize;
    if (list) {
      nextSize = list.size <= list.total + 20 ? list.size + 20 : list.total;
    }
    return (
      <div className="pressResume_container">
        <StyledBoxInside>
          <StyledWrapperSearch>
            {Object.keys(filter).length > 0 && (
              <StyledButtonClear onClick={this.clearFilter}>
                Borrar filtros
              </StyledButtonClear>
            )}
            <SearchFilterMini
              onClick={this.onClick}
              modalActive={modalActive}
              closeModal={this.closeModal}
              openModal={this.openModal}
              dataForm={dataForm}
              setFilter={this.setFilter}
              filter={filter}
            />
          </StyledWrapperSearch>
          <StyledWrapperEmployerDirectory>
            <InfiniteScroller
              page={list ? list.page : 0}
              loadMore={() =>
                this.nextScroll({
                  size: nextSize,
                  ...filter
                })
              }
            >
              {list && (
                <div className="Employee-wrapperTable">
                  <SelectEmployerDirectory
                    data={list.content}
                    setEmployeeSelected={setEmployeeSelected}
                    resetRow={resetRow}
                  />
                </div>
              )}
            </InfiniteScroller>
          </StyledWrapperEmployerDirectory>

          <StyledWrapperPaginator>
            {list && (
              <PaginatorVertical
                visibleItems={list.size <= list.total ? list.size : list.total}
                totalItems={list.total}
                loadMore={() =>
                  this.nextScroll({
                    size: nextSize,
                    ...filter
                  })
                }
              />
            )}
          </StyledWrapperPaginator>
        </StyledBoxInside>
      </div>
    );
  }
}

export default SelectEmployeeDirectory;
